<mib-modal size="md" [showCloseButton]="false">
  <svg mib-modal-header mib-icon name="triangle-alert" class="shrink-0 size-6"></svg>
  <span mib-modal-header>Protected Health Information (Beta)</span>

  <div mib-modal-content>
    <div class="text-gray-900 flex flex-col gap-3">
      <p>
        To publish a case on Medinbox Intelligence, all Protected Health Information must be
        removed.
      </p>
      <p>
        By publishing this video, you confirm that it complies with applicable policies and
        regulations and that you are responsible for the content.
      </p>
      <p>Medinbox does not review patient information before publication.</p>
    </div>
    <div class="text-gray-700 text-xs px-5.5 py-4 border border-mib-hairline rounded-mib mt-4">
      <strong>You can still</strong>
      <ul class="list-disc ml-4">
        <li>Remove or edit the detected PHI</li>
        <li>Re-upload the video after modification</li>
        <li>Cancel publication</li>
      </ul>
    </div>
  </div>

  <div mib-modal-footer class="flex not-expanded:flex-col gap-3 items-end justify-end">
    <button
      mibButton
      type="button"
      theme="secondary"
      size="lg"
      (click)="dialogRef.close(PiiDetectionChoice.Cancel)">
      Cancel
    </button>
    <div class="flex gap-3">
      <button
        mibButton
        type="button"
        theme="secondary"
        size="lg"
        (click)="dialogRef.close(PiiDetectionChoice.Review)">
        Review PHI
      </button>
      <button
        mibButton
        type="button"
        theme="danger"
        size="lg"
        (click)="dialogRef.close(PiiDetectionChoice.Publish)">
        Publish anyway
      </button>
    </div>
  </div>
</mib-modal>
